import { retry, timeout } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';

@Injectable({
    providedIn: 'root'
})
export class AppSettingsProvider {
    constructor(protected httpClient: HttpClient) { }

    public loadSettings(): Promise<void> {
        return new Promise((resolve, reject) => {
            this.httpClient
                .get<any>('config')
                .pipe(
                    timeout(1000),
                    retry(3)
                )
                .subscribe(res => {
                    AppConfig.apiRootUrl = res.app.apiUrl;
                    AppConfig.hideGetDataFromGeuscalculator = JSON.parse(res.app.hideGetDataFromGeuscalculator.toLowerCase());

                    AppConfig.authAuthorizeUrl = res.identity.authorizeUrl;
                    AppConfig.authAuthority = res.identity.authority;
                    AppConfig.authEndSessionUrl = res.identity.endSessionUrl;
                    AppConfig.authClientId = res.identity.webClientId;
                    AppConfig.authScope = res.identity.scope;
                    AppConfig.authReturnUrl = res.identity.returnUrl;
                    AppConfig.operatorCVR = res.identity.operatorCVR;

                    AppConfig.overrulingScreeningRules.exceedingFactorLimitation =
                        res.overrulingScreeningRules.exceedingFactorLimitation;
                    AppConfig.overrulingScreeningRules.sumV1PolygonAreaExceedLimitation =
                        res.overrulingScreeningRules.sumV1PolygonAreaExceedLimitation;
                    AppConfig.overrulingScreeningRules.sumV2PolygonAreaExceedLimitation =
                        res.overrulingScreeningRules.sumV2PolygonAreaExceedLimitation;

                    const connStr = Object.keys(res).find(k => k.toLowerCase() === 'applicationinsights_connection_string');
                    AppConfig.appInsightsConnectionString = connStr ? res[connStr] : null;
                    resolve();
                },
                    error => {
                        reject(error);
                    }
                );
        });
    }
}
